import Api from './Api';

const get = (payload) => {
    const path = '/settings';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;
    return Api.getRequest({
        endpoint
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/update/settings',
        method: 'PUT',
        data: payload
    });
};

export default {
    get,
    update
};
